import InteractionResultUtil from "/js/util/interaction-result-util";
import Strings from "/js/util/strings.js";

/**
 * Generates the do-this-now user-generated content for the recap view.
 * Not to be confused with the result view at the end of an interaction (though they are related).
 */
export default class DoThisNowResultUtil {

  static makeHtml(interaction, answers, callback) {
    // cl("makeHtml()", interaction, JSON.stringify(answers));

    if (!answers) {
      clw('ERROR: no answers');
      callback(this.#makeEmptyResult());
    } else if (!interaction) {
      clw('ERROR: No interaction object');
      callback(this.#makeEmptyResult());
    } else {
      switch (answers.type) {
        case "answers":
          const onComplete = (html) => { callback(html || this.#makeEmptyResult()) };
          DoThisNowResultUtil.makeAnswerTypeHtml(interaction, answers, onComplete);
          break;
        case "leftright":
          const html = DoThisNowResultUtil.makeLeftRightHtml(interaction, answers);
          callback(html);
          break;
        default:
          clw('ERROR: bad value for answers.type:', answers.type);
          callback(this.#makeEmptyResult());
          break;
      }
    }
  }

  static #makeEmptyResult() {
    const emptyDiv =  $(`<div class="recap" style="display: none"></div>`);
    return emptyDiv;
  }

  /**
   * Creates html output for answers of type "answers" (questionnaire).
   * Returns result in callback
   */
  static makeAnswerTypeHtml(interaction, answers, callback) {

    const answersArray = answers.answers;
    if (!answersArray) {
      clw("WARNING: Missing answers array:", answers);
      callback(null);
      return;
    }

    // TODO: Why is "answers" being used below instead of "answersArray"? I forget if there's a justifiable reason.

    const output = InteractionResultUtil.findCorrectOutput(
        answers, interaction.result, interaction.questions);
    cl('chosen output:', output);

    if (output && output.type === "html") {

      // Load external html file
      // Note that this file is probably a fully formed html document.
      // Make sure that inserting it into our document doesn't create layout bugs.
      const onComplete = (html) => {
        const o = {
          doThisNowCopy: output.subtitle || "",
          html: html
        };
        const s = this.#externalHtmlTemplate(o);
        // cl('makeAnswerTypeHtml()', s);
        callback(s);
      };
      InteractionResultUtil.stringReplaceHtmlAsync(interaction, output, answers, onComplete);

    } else {

      // Make html of question/answer format
      const o = {};
      o.doThisNowCopy = output ? output.resource : "";

      if (answersArray.length !== interaction.questions.length) {
        clw("WARNING: Number of questions and answers don't match");
      }
      o.items = [];
      for (let i = 0; i < interaction.questions.length; i++) {
        const question = interaction.questions[i];
        const answerIndex = answersArray[i][0];
        const item = {};

        item.questionHeading = Strings.get("recap_qaitem_questionlabel");
        item.questionText = question.question;

        item.answerHeading = Strings.get("recap_qaitem_answerlabel");
        item.answerText = question.choices[answerIndex].title;

        if (!item.answerText) {
          clw("WARNING: No match for answer", answer);
          item.answerText = "";
        }
        o.items.push(item);
      }
      const html = DoThisNowResultUtil.#questionAnswerTemplate(o);
      callback(html);
    }
  }

  /**
   * Creates html output for answers of type "leftright" (drag-and-drop and list-maker).
   * Note how the json interaction field names are slightly different for each, below.
   */
  static makeLeftRightHtml(interaction, answers) {

    if (!answers.left || !answers.right) {
      clw("WARNING: answer is missing left or right properties:", answers.left, answers.right);
      return null;
    }

    const o = {};

    const resultOutputObject = InteractionResultUtil.findCorrectOutput(
        answers, interaction.result, interaction.questions);
    if (!resultOutputObject) {
      clw("WARNING: no result output found.");
      return null;
    }
    // cl('resultOutputObject:', resultOutputObject);
    o.doThisNowCopy = resultOutputObject.resource;

    o.leftBucket = {
      heading: interaction.leftText || interaction.leftTitle || "",
      items: []
    };
    o.rightBucket = {
      heading: interaction.rightText || interaction.rightTitle || "",
      items:[]
    };

    const elements = interaction.pieces || interaction.items;
    if (!elements) {
      clw("WARNING: No 'pieces' data");
      return null;
    }

    for (let i = 0; i < elements.length; i++) {
      const element = elements[i];
      const text = element.title || element.body;
      if (answers.left.indexOf(i) > -1) {
        o.leftBucket.items.push(text);
      } else if (answers.right.indexOf(i) > -1) {
        o.rightBucket.items.push(text);
      } else {
        clw("WARNING: Missing 'answers' for element at index: ", i);
      }
    }

    const s = DoThisNowResultUtil.#leftRightTemplate(o);
    // cl('makeLeftRightHtml()', s);
    return s;
  }

  // TODO: inlined javascript must be IE11 compatible! (ie, no ES6 stuff).
  static #QUESTION_ANSWER_TEMPLATE_ORIGINAL = `
      <div class="recapSectionContent qaTemplate">
        <div class="copy"><%=doThisNowCopy%></div>
        <div class="doThisNowUserContent">
          <% 
          
              for (var i = 0; i < items.length; i++) { 
                var item = items[i]; 
          %>
            <div class="qaItem">
              <div class="qaRow isQuestion">
                <div class="qaHeading"><%=item.questionHeading%></div><div class="qaText"><%=item.questionText%></div>
              </div>  
              <div class="qaRow">
                <div class="qaHeading"><%=item.answerHeading%></div><div class="qaText"><%=item.answerText%></div>
              </div>
            </div>
          <% 
            } 
          %>
        </div>
      </div>
      `;

  static #QUESTION_ANSWER_TEMPLATE = `
      <div class="recapSectionContent qaTemplate">
        <div class="copy"><%=doThisNowCopy%></div>
        <div class="doThisNowUserContent">
          
          <%           
          var col1StartIndex = 0;
          var col1EndIndex = Math.ceil((items.length - 1) / 2);
          var col2StartIndex = col1EndIndex + 1;
          var col2EndIndex = items.length - 1;
          %>

          <div class="column1">
            <%
            for (var i = col1StartIndex; i <= col1EndIndex; i++) { 
                var item = items[i]; 
            %>          
              <div class="qaItem">
                <div class="qaRow isQuestion">
                  <div class="qaHeading"><%=item.questionHeading%></div><div class="qaText"><%=item.questionText%></div>
                </div>  
                <div class="qaRow">
                  <div class="qaHeading"><%=item.answerHeading%></div><div class="qaText"><%=item.answerText%></div>
                </div>
              </div>         
            <% 
            } 
            %>
          </div
          ><div class="column2">
            <%
            for (var i = col2StartIndex; i <= col2EndIndex; i++) { 
                var item = items[i]; 
            %>          
              <div class="qaItem">
                <div class="qaRow isQuestion">
                  <div class="qaHeading"><%=item.questionHeading%></div><div class="qaText"><%=item.questionText%></div>
                </div>  
                <div class="qaRow">
                  <div class="qaHeading"><%=item.answerHeading%></div><div class="qaText"><%=item.answerText%></div>
                </div>
              </div>         
            <% 
            } 
            %>
          </div>           

        </div>
      </div>
      `;
  static #questionAnswerTemplate = _.template(DoThisNowResultUtil.#QUESTION_ANSWER_TEMPLATE);

  static #LEFT_RIGHT_TEMPLATE = `
      <div class="recapSectionContent leftRightTemplate">
        <div class="copy"><%=doThisNowCopy%></div>
        <div class="doThisNowUserContent">         
          <%
          if (leftBucket.items.length > 0) { 
          %>
          <div class="bucket">
            <div class="bucketHeading"><%=leftBucket.heading%></div>
              <% 
              for (var i = 0; i < leftBucket.items.length; i++) {
                var item = leftBucket.items[i]; 
              %>
              <div class="bucketLine"><%=item%></div>
              <% 
              } 
              %>
          </div>
          <%
          }
          %>
          <%
          if (rightBucket.items.length > 0) { 
          %>
          <div class="bucket">
            <div class="bucketHeading"><%=rightBucket.heading%></div>
              <% 
              for (var i = 0; i < rightBucket.items.length; i++) {
                var item = rightBucket.items[i]; 
              %>
              <div class="bucketLine"><%=item%></div>
              <% 
              } 
              %>
          </div>
          <%
          }
          %>
        </div>
      </div>
      `;
  // Note, class "count-0" will hide the section.
  static #leftRightTemplate = _.template(DoThisNowResultUtil.#LEFT_RIGHT_TEMPLATE);

  static #EXTERNAL_HTML_TEMPLATE = `
      <div class="recapSectionContent htmlTemplate">
        <div class="copy"><%=doThisNowCopy%></div>
        <div class="doThisNowUserContent">
          <%= html %>
        </div>
      </div>
      `;
  static #externalHtmlTemplate = _.template(DoThisNowResultUtil.#EXTERNAL_HTML_TEMPLATE);
}
